import {Service} from '../utils/Service';

export default{
      login(data) {
        return Service({
          url: 'operationApi/busShopUser/login',
          data,
          method: 'POST'
        })
      },

      getUserInfo(data) {
          return Service({
            url: 'managerApi/syslogin/getUserInfo',
            data,
            method: 'POST'
          })
      },
      logout(data) {
        return Service({
          url: 'managerApi/syslogin/sysUserlogout',
          data,
          method: 'POST'
        })
      },
      updateUserPsw(data) {
        return Service({
          url: 'operationApi/cashierIndex/updateUserPsw',
          data,
          method: 'POST'
        })
      },
      register(data) { //注册
        return Service({
          url: 'operationApi/busShopUser/register',
          data,
          method: 'POST'
        })
      },
      checkLoginName(data) { //验证登绿账号是否存在
        return Service({
          url: 'operationApi/busShopUser/checkLoginName',
          data,
          method: 'POST'
        })
      },
      queryBusOrgCategoryByParentId(data) { //查询全部机构分类
        return Service({
          url: 'operationApi/busOrgCategoryApi/queryBusOrgCategoryByParentId',
          data,
          method: 'POST' ,
        })
  },

}



// WEBPACK FOOTER //
// ./src/api/login.js